import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer";
import DatabaseIcon from "@/assets/icons/database.svg?react";
import ExportIcon from "@/assets/icons/export.svg?react";
import { useUserExportDownload } from "@/features/users/settings/hooks/useUserExportDownload";
import { ExportDataSectionProps } from "@/features/users/settings/types";

import "../styles.css";

const ExportDataSection = ({ userId, fullName }: ExportDataSectionProps) => {
  const { t } = useTranslation();
  const { startDownload, isDownloading } = useUserExportDownload();

  return (
    <div className="user-settings-card flex flex-col gap-200">
      <div className="flex items-center gap-200">
        <BaseSvgRenderer component={DatabaseIcon} width="20" height="20" />
        <h3 className="header-m-medium">{t("users.labels.retrieveData")}</h3>
      </div>

      <p className="body-m-regular">
        {t("users.labels.retrieveDataDescription")}
      </p>

      <BaseButton
        className="self-start"
        onClick={() => startDownload(userId, fullName)}
        disabled={isDownloading(userId)}
        leadingIcon={
          isDownloading(userId) ? (
            <BaseSpinner size="small" />
          ) : (
            <BaseSvgRenderer
              component={ExportIcon}
              width="20"
              height="20"
              stroke="white"
            />
          )
        }
      >
        {t("users.labels.export")}
      </BaseButton>
    </div>
  );
};

export default ExportDataSection;
